<template>
  <div class="flex flex-1 flex-col">
    <v-top-nav
      :logo="'logo-white'"
      :sublogo="teams[$route.params.team].account.team.name"
      home="Dashboard"
      style="z-index: 999"
    >
      <div class="relative cursor-pointer">
        <v-avatar
          :initials="$h.getInitials(teams[$route.params.team].account)"
          :name="$h.formatName(teams[$route.params.team].account)"
          :width="46"
          @click.stop.native="$eventbus.$emit('toggleDropdown', profileDropdownUid)"
        ></v-avatar>
        <v-dropdown :dropdownUid="profileDropdownUid" :data="profileDropdown"></v-dropdown>
      </div>
    </v-top-nav>
    <v-container class="bg">
      <modal
        name="delete-team"
        class="envivo-modal delete-modal"
        @before-open="$h.toggleHtmlScroll"
        @before-close="$h.toggleHtmlScroll"
        transition="pop-out"
        height="auto"
        adaptive
        :maxWidth="502"
        width="90%"
        scrollable
      >
        <div class="modal-wrapper">
          <div class="modal-title">{{ $t("modals.deleteTeamTitle") }}</div>
          <div class="relative">
            <div class="modal-content mt-8" style="padding: 15px 45px">
              <label>{{ $t("labels.requestPin") }}</label>
              <p>
                {{ $t("texts.getDeleteTeamPin") }}
              </p>
              <v-button
                primary
                @click.native="getDeleteTeamPin"
                class="mb-12"
                :active="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
              >
                {{ $t("actions.getDeleteTeamPin") }}
              </v-button>
              <label class="mt-8">{{ $t("labels.enterPinAndPw") }}</label>
              <p>
                {{ $t("texts.deleteTeam") }}
              </p>
              <v-col class="col-12 p-0">
                <v-textfield
                  :label="$t('labels.deleteTeamPin')"
                  v-model="pin"
                  v-validate="'required'"
                  name="pin"
                  :data-vv-as="$t('team.pin')"
                  :error="errors.first('pin')"
                ></v-textfield>
                <v-textfield
                  :label="$t('labels.deleteTeamPassword')"
                  v-model="password"
                  type="password"
                  v-validate="'required'"
                  name="password"
                  :data-vv-as="$t('team.password')"
                  :error="errors.first('password')"
                ></v-textfield>
              </v-col>
            </div>
            <div class="modal-buttons mb-8" style="padding: 15px 45px">
              <a class="v1 simple" @click="$modal.hide('delete-team')">{{ $t("actions.cancel") }}</a>
              <v-button
                danger
                @click.native="deleteThisTeam"
                :active="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
              >
                {{ $t("actions.deleteTeam") }}
              </v-button>
            </div>
          </div>
        </div>
      </modal>
      <v-row>
        <h1 class="w-full text-primary text-center mb-16">
          {{ $t("titles.expiredSubscription") }}
        </h1>
        <p class="w-full text-center mb-4">
          {{ $t("texts.teamSubscription.noValidSubscription.part1") }}
        </p>
        <p
          class="w-full text-center"
          v-if="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
        >
          {{ $t("texts.teamSubscription.noValidSubscription.part2a") }}
        </p>
        <p
          class="w-full text-center"
          v-if="teams[$route.params.team] && !teams[$route.params.team].account.role.includes('owner')"
        >
          {{ $t("texts.teamSubscription.noValidSubscription.part2b") }}
        </p>
        <div
          class="w-full flex justify-around flex-wrap"
          style="margin-top: 100px"
          v-if="teams[$route.params.team] && teams[$route.params.team].account.role.includes('owner')"
        >
          <v-button success :btnWidth="234" @click.native="openBilling" class="uppercase mb-4">{{
            $t("actions.manageSubscription")
          }}</v-button>
          <v-button danger :btnWidth="234" @click.native="openDeleteTeamModal" class="uppercase mb-4">{{
            $t("actions.deleteTeam")
          }}</v-button>
        </div>
      </v-row>
    </v-container>
    <div class="bg-footer"></div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";

export default {
  name: "TeamSubscription",
  props: {},
  data() {
    return {
      chargebeeInstance: null,
      pin: "",
      password: "",
      profileDropdownUid: this.$h.createUniqueUid(),
      profileDropdown: [
        {
          title: "",
          options: [],
        },
        {
          title: "",
          options: [],
        },
        {
          title: "",
          options: [],
        },
      ],
    };
  },
  created() {
    this.initChargebee();
    this.setProfileDropdown(this.$route.params.team);
  },
  methods: {
    ...mapActions([
      "getAuthAccount",
      "getTeamSubscription",
      "postTeamSubscription",
      "postDeleteTeam",
      "deleteTeam",
      "logout",
    ]),
    initChargebee() {
      let site;
      this.teams && this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.team.cb_site
        ? (site = this.teams[this.$route.params.team].account.team.cb_site)
        : (site = "");
      try {
        this.chargebeeInstance = window.Chargebee.getInstance();
      } catch (err) {
        this.chargebeeInstance = window.Chargebee.init({
          site,
        });
        this.chargebeeInstance = window.Chargebee.getInstance();
      }
      this.chargebeeInstance.setPortalCallbacks({
        loaded: () => {},
        close: () => {
          this.chargebeeInstance.logout();
          this.getTeamSubscription({ team: this.$route.params.team }).then(() => {
            this.getAuthAccount({ team: this.$route.params.team }).then(() => {
              if (this.teams[this.$route.params.team].account.team.subscription !== null) {
                this.$goTo("Dashboard");
              }
            });
          });
        },
        visit: () => {},
      });
    },
    openBilling() {
      if (this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")) {
        this.postTeamSubscription({ team: this.$route.params.team })
          .then((res) => {
            this.chargebeeInstance.setPortalSession(res);
            const cbPortal = this.chargebeeInstance.createChargebeePortal();
            cbPortal.open();
          })
          .catch(() => {
            this.$snotify.error(this.$t("toasts.defaultError.error"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          });
      } else {
        this.$h.showSubscriptionErrorModal(
          this.$modal,
          this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")
        );
      }
    },
    openDeleteTeamModal() {
      this.$modal.show("delete-team");
    },
    getDeleteTeamPin() {
      if (this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")) {
        const vm = this;
        vm.postDeleteTeam()
          .then(() => {
            vm.$snotify.success(vm.$t("toasts.getDeleteTeamPin.success"), vm.$t("toasts.success"), {
              icon: vm.$successIcon,
            });
          })
          .catch((err) => {
            if (err.response && !err.response.data.error.custom) {
              this.$snotify.error(this.$t("toasts.getDeleteTeamPin.error"), this.$t("toasts.error"), {
                timeout: 0,
                icon: this.$errorIcon,
              });
            }
          });
      } else {
        this.$h.showSubscriptionErrorModal(this.$modal);
      }
    },
    deleteThisTeam() {
      if (this.teams[this.$route.params.team] && this.teams[this.$route.params.team].account.role.includes("owner")) {
        this.$validator.validateAll().then((result) => {
          if (result) {
            const data = {
              pin: this.pin,
              password: this.password,
            };
            this.deleteTeam(data)
              .then(() => {
                this.$snotify.success(this.$t("toasts.deleteTeam.success"), this.$t("toasts.success"), {
                  icon: this.$successIcon,
                });
                this.logout();
              })
              .catch((err) => {
                if (err.response && !err.response.data.error.custom) {
                  this.$snotify.error(this.$t("toasts.deleteTeam.error"), this.$t("toasts.error"), {
                    timeout: 0,
                    icon: this.$errorIcon,
                  });
                }
              });
          } else {
            this.$snotify.error(this.$t("toasts.deleteTeam.validation"), this.$t("toasts.error"), {
              timeout: 0,
              icon: this.$errorIcon,
            });
          }
        });
      } else {
        this.$h.showSubscriptionErrorModal(this.$modal);
      }
    },
    setProfileDropdown(currentTeam) {
      this.profileDropdown = [
        {
          title: "",
          options: [],
        },
        {
          title: "",
          options: [],
        },
        {
          title: "",
          options: [],
        },
      ];
      this.profileDropdownUid = this.$h.createUniqueUid();
      if (currentTeam && this.teams[currentTeam] && this.teams[currentTeam].account) {
        let teamCounter = 0;
        Object.keys(this.teams).forEach((key) => {
          if (
            this.teams[key].authenticated &&
            this.teams[key].cognito.username === this.teams[currentTeam].cognito.username &&
            currentTeam !== key
          ) {
            this.profileDropdown[1].options.push({
              label: this.teams[key].team.name,
              method: () => {
                this.$eventbus.$emit("changeTeam", { uid: key });
              },
            });
            teamCounter += 1;
          }
        });
        this.profileDropdown[0].title = this.$h.formatName(this.teams[currentTeam].account, true);
        if (teamCounter > 0) {
          this.profileDropdown[1].title = this.$t("dropdowns.changeTeam");
        }
        this.profileDropdown[2].title = this.$t("dropdowns.signOut");
        this.profileDropdown[2].options.push({
          label: this.$t("actions.signOutFromTeam", {
            team: this.teams[currentTeam].team.name,
          }),
          method: () => {
            this.logout();
          },
        });
        if (teamCounter > 0) {
          this.profileDropdown[2].options.push({
            label: this.$t("actions.signOutFromTeams"),
            method: () => {
              this.logout({ logoutAllTeams: true });
            },
          });
        }
      }
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
    }),
  },
};
</script>

<style lang="scss">
.bg {
  flex: 1;
  background: url("../assets/svg/subscription_bg.svg") no-repeat bottom center;
  z-index: 100;
}
.bg-footer {
  height: 50px;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  background-color: #7378c9;
}
</style>
